function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "thumb_down_alt");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "thumb_down_alt",
  stroke: "current",
  strokeWidth: 0,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("polygon", {
  id: "Path",
  points: "20 20 0 20 0 0 20 0"
}), React.createElement("path", {
  d: "M14,6 L14,11.1715729 C14,11.7020059 13.7892863,12.2107137 13.4142136,12.5857864 L8.63265487,17.3673451 C8.24213058,17.7578694 7.6089656,17.7578694 7.2184413,17.3673451 C6.96611875,17.1150226 6.86736933,16.747365 6.95931315,16.4025757 L8,12.5 L8,12.5 L4.15156403,12.5 C3.04699453,12.5 2.15156403,11.6045695 2.15156403,10.5 C2.15156403,10.205584 2.21656517,9.91479901 2.34192662,9.64840593 L4.45957368,5.14840593 C4.78944891,4.44742107 5.49448698,4 6.26921109,4 L12,4 C13.1045695,4 14,4.8954305 14,6 Z",
  id: "Path-2",
  stroke: "current",
  strokeWidth: 1.25,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M16,4 L18,4 L18,4 L18,12.5 L14,12.5 L14,6 C14,4.8954305 14.8954305,4 16,4 Z",
  id: "Rectangle",
  stroke: "current",
  strokeWidth: 1.25,
  strokeLinecap: "round"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/thumb-down-alt.2fbca463.svg";
export { SvgComponent as ReactComponent };